// Observer Registry
const requestObservers = new Set();

// Function to  request observer
const addRequestObservers = (observer) => {
  if (!requestObservers.has(observer)) requestObservers.add(observer);
};
const removeRequestObservers = (observer) => {
  requestObservers.delete(observer);
};
const removeAllRequestObservers = () => {
  requestObservers.clear();
};
const notifyRequestObservers = (responseData) => {
  requestObservers.forEach((observer) => {
    observer(responseData);
  });
};

const notifyAndRemoveAllRequestObservers = (responseData) => {
  notifyRequestObservers(responseData);
  removeAllRequestObservers();
};

const businessObserver = {
  add: addRequestObservers,
  remove: removeRequestObservers,
  removeAll: removeAllRequestObservers,
  notify: notifyRequestObservers,
  notifyAndRemove: notifyAndRemoveAllRequestObservers,
};

export default businessObserver;
